import { put, call, take, fork } from 'redux-saga/effects'
import { getLocalizationStringsService } from '../../api/localizations'
import { localizationsGetSuccess } from '../../reducers/localizations/action'
import { LOCALIZATIONS_GET } from '../../reducers/localizations/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 * @param {*} payload
 */
function* localizationsGetFlow(payload) {
  try {
    const { languageCode } = payload
    const response = yield call(getLocalizationStringsService, languageCode)

    yield put(localizationsGetSuccess(response.data))
    yield put(operationSuccess())
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 */
export default function* localizationsGetWatcher() {
  while (true) {
    const action = yield take(LOCALIZATIONS_GET)
    const { payload } = action

    yield fork(generalSaga, localizationsGetFlow, payload)
  }
}
